import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE_AMOUNT, PRICE_CURRENCY, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-232" data-mp="1mmzf07wtvb5p">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-233" data-mp="1hoxr99oginnw">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-234" data-mp="tzmq3r372r98">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-235" data-mp="p00bpebmr4yu">
            Discover Your Complete <em className="text-red-300" data-id="element-236" data-mp="13xaxbghzlr8a">SALSA &amp; BACHATA READY™</em> Bundle
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-237" data-mp="yxeqzalthnpk">
            Get a Full Year of Salsa &amp; Bachata Classes Ready in Just 5 Minutes.
          </p>
          <img src={PRODUCT_IMAGE} alt="The SALSA & BACHATA READY™ box with its six digital teaching volumes." className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-238" data-mp="2ad3ec32zgoqw" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-239" data-mp="ujbn66sya8x5">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-240" data-mp="zjpvzr2dlmw8">Your Complete Bundle Includes:</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-241" data-mp="13ip1pdvxlnoq">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-242" data-mp="6vkcf7n263xz">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-243" data-mp="bs11q55zuocn">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-244" data-mp="ftm8d8rxq6ee" />
                </span>
                <span data-id="element-245" data-mp="kmfcbufkxapf">
                  <span className="block font-medium leading-snug" data-id="element-246" data-mp="kmysp6pkzr1c">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-247" data-mp="3k6jbqcfhwdyw">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-248" data-mp="vepap1gjv3v6">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-249" data-mp="qetf9qlx4kr8">Get the Complete Bundle for</p>
            <p className="whitespace-nowrap font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-250" data-mp="157d7hw7j57tw">
              {PRICE_AMOUNT}
              <span className="ml-2 text-2xl tracking-normal text-slate-900/70 sm:text-3xl" data-id="element-251" data-mp="cho1t5jvkjly">{PRICE_CURRENCY}</span>
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-252" data-mp="7k4pib6qmgwn">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-253" data-mp="hfzf5q9dpc8x" />
            One-time payment. No subscription.
          </p>

          <CtaButton label="Get the Complete Bundle Now" className="mt-8 w-full" data-id="element-254" data-mp="1wvooqpjvxsrv" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-255" data-mp="1svo0yeawc585">
            {offerIncludes.map(item => <li key={item} data-id="element-256" data-mp="20dufxpmvfjcj">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}